import Button, { GhostButton, GrayButton, HollowedButton, NormalButton, TintedButton } from '@components/General/Button';
import { DatePickerCalendar } from '@components/General/DatePicker';
import { TextInput } from '@components/General/TextInput';
import { useEffect, useState } from 'react';
import styles from '@styles/components/Comunicaciones/AltaComunicacionGeneral.module.css';
import ResultPopup from '@components/General/ResultPopup';
import { usePopup } from '@contexts/popupContext';
import Utils from '@utils/Utils';
import DeleteConfirmationPopup from '@components/General/DeleteConfirmationPopup';
import { Application } from '@core/Application';
import { CreateCommunicationRequest } from '@services/CommunicationsService';

interface AltaComunicacionesGeneralProps {
    orgID: string
    timezone: string
}

export const AltaComunicacionesGeneral = ({orgID, timezone}: AltaComunicacionesGeneralProps) => {

    const {showPopup} = usePopup()
    const [value, setValue] = useState('');
    const [date, setDate] = useState(new Date());
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');

    useEffect(() => {
        fetchCurrentMessage()
    },[orgID])


    const fetchCurrentMessage = async () => {
        setLoading(true)

        try {
            const communicationsService = Application.shared().coreDependencies.communicationsService;
            const json = await communicationsService.getCommunication(orgID);
            console.log(json);
            
            if (json) {
                setValue(json.text)
                setDate(new Date(json.expirationTimestamp))
            }

        } catch (error) {
            console.error(error)
        } finally {
            setLoading(false)
        }
    }

    const validateInput = () => {
        if (value.trim() === '') {
            setError('El campo no puede estar vacío');
            return false;
        }

        setError('')
        return true
    }

    const handleAdd = async () => {
        if (!validateInput()) {
            return;
        }
        setLoading(true)
        const expirationDate = new Date(date);
        expirationDate.setHours(23, 59, 59, 999);
        const data: CreateCommunicationRequest = {
            text: value,
            expiration: expirationDate.getTime()
        };

        try {
            const communicationsService = Application.shared().coreDependencies.communicationsService;
            const json = await communicationsService.createCommunication(orgID, data);
            console.log(json);
            showPopup(() => <ResultPopup result='Mensaje guardado correctamente!' succesful={true}/>)

        } catch (error) {
            console.error(error)
            showPopup(() => <ResultPopup result='No se ha podido guardar el mensaje...' succesful={false}/>)
        } finally {
            setLoading(false)
        }
    }

    const handleDeleteWrapper = () => {
        showPopup(() => 
            <DeleteConfirmationPopup
                title="Eliminar Comunicacion"
                message={`¿Estás seguro que quieres eliminar la comunicacion?`}
                onDelete={handleDelete}
                onSuccess={() => {}}
                successMessage="Comunicacion eliminada correctamente!"
                errorMessage="Error al eliminar comunicacion..."
                confirmButtonText="Eliminar"
            />, 
            false
        )
    }
    
    const handleDelete = async () => {
        setLoading(true)

        try {
            const communicationsService = Application.shared().coreDependencies.communicationsService;
            const json = await communicationsService.deleteCommunication(orgID);
            console.log(json);

            setDate(new Date())
            setValue('')
            showPopup(() => <ResultPopup result='Eliminado mensaje correctamente!' succesful={true}/>)
        } catch (error) {
            showPopup(() => <ResultPopup result='No se ha podido eliminar el mensaje...' succesful={false}/>)
            console.error(error)
        } finally {
            setLoading(false)
        }
    }

    return (
        <div className={styles.container}>
            <div className={styles['text-input-container']}>
                <TextInput
                    label="Texto que deseas comunicar"
                    placeholder="Ingresa el texto aqui..."
                    type="text"
                    value={value}
                    onChange={setValue}
                    error={error}
                />
            </div>
            <div className={styles['date-picker-container']}>
                <p style={{fontSize: '14px'}}>Selecciona la fecha donde se deja de comunicar el mensaje</p>
                <DatePickerCalendar
                    value={date}
                    setValue={setDate}
                    disabledPast={true}
                    daysStyle={{height: '32px', width: '32px'}}
                    weekdayLabelStyle={{height: '30px', width: '32px'}}
                    calendarHeaderStyle={{fontSize: '12px'}}
                    calendarStyle={{width: '100%', height: '313px'}}
                />
            </div>
            <div className={styles['footer-container']}>
                <div className={styles['button-container']}>
                    <GrayButton text='Eliminar' onClick={handleDeleteWrapper} loading={loading}/>
                </div>
                <div className={styles['button-container']}>
                    <NormalButton text="Aceptar" onClick={handleAdd} loading={loading}/>
                </div>
            </div>
        </div>
    );
};
